// extracted by mini-css-extract-plugin
module.exports = {"caption":"EmailReport_caption__1sfG0","button":"EmailReport_button__2GqLL","label":"EmailReport_label__13j2F"};